(function () {
  function update() {
    const drawer = document.getElementById('mini-cart-drawer');
    const host = document.getElementById('moosedesk-widget-host');
    if (!host) return;
    const cartOpen = drawer && drawer.classList.contains('active');
    host.style.setProperty('display', cartOpen ? 'none' : 'block', 'important');
  }
  setInterval(update, 300);
})();